module.exports = __webpack_public_path__ + "static/media/31.90fdf922.jpg";